var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneBill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Phone Bill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.40254 20.7894C2.6709 21.051 3.00168 21.1818 3.39488 21.1818H11.5142C11.9074 21.1818 12.2382 21.051 12.5066 20.7894C12.7749 20.5278 12.9091 20.2057 12.9091 19.8229L12.9091 19.7273L22 19.7273L21.3636 18.6364L22 17.5L21.3636 16.3636L22 15.2273L21.3636 14.0909L22 12.9545L21.3636 11.8182L22 10.6818L21.3636 9.54545L22 8.45455H12.9091V4.35894C12.9091 3.97615 12.7749 3.65397 12.5066 3.39238C12.2382 3.13079 11.9074 3 11.5142 3H3.39488C3.00168 3 2.6709 3.13079 2.40254 3.39238C2.13418 3.65397 2 3.97615 2 4.35894V19.8229C2 20.2057 2.13418 20.5278 2.40254 20.7894ZM12.9091 9.09091L12.9091 19.0909H20.9091V9.09091H12.9091ZM2.62094 19.817V17.1586H12.2881V19.817C12.2881 20.0069 12.207 20.1809 12.0446 20.3392C11.8823 20.4974 11.7037 20.5765 11.5089 20.5765H3.40016C3.20536 20.5765 3.02679 20.4974 2.86445 20.3392C2.70211 20.1809 2.62094 20.0069 2.62094 19.817ZM12.2881 16.5533H2.62094V5.80085H12.2881V16.5533ZM12.2881 5.19559H2.62094V4.36482C2.62094 4.17493 2.70211 4.00087 2.86445 3.84263C3.02679 3.68439 3.20536 3.60527 3.40016 3.60527H11.5089C11.7037 3.60527 11.8823 3.68439 12.0446 3.84263C12.207 4.00087 12.2881 4.17493 12.2881 4.36482V5.19559Z",
    fill: "#183883"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Union_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.35 10H19.05V15.15H18.35V10Z",
    fill: "#183883"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.35 10H16.05V15.15H15.35V10Z",
    fill: "#183883"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 17.35C18 17.1667 18.0708 17.0042 18.2125 16.8625C18.3542 16.7208 18.5167 16.65 18.7 16.65C18.8833 16.65 19.0458 16.7208 19.1875 16.8625C19.3292 17.0042 19.4 17.1667 19.4 17.35C19.4 17.5333 19.3292 17.6958 19.1875 17.8375C19.0458 17.9792 18.8833 18.05 18.7 18.05C18.5167 18.05 18.3542 17.9792 18.2125 17.8375C18.0708 17.6958 18 17.5333 18 17.35Z",
    fill: "#183883"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 17.35C15 17.1667 15.0708 17.0042 15.2125 16.8625C15.3542 16.7208 15.5167 16.65 15.7 16.65C15.8833 16.65 16.0458 16.7208 16.1875 16.8625C16.3292 17.0042 16.4 17.1667 16.4 17.35C16.4 17.5333 16.3292 17.6958 16.1875 17.8375C16.0458 17.9792 15.8833 18.05 15.7 18.05C15.5167 18.05 15.3542 17.9792 15.2125 17.8375C15.0708 17.6958 15 17.5333 15 17.35Z",
    fill: "#183883"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_3",
    d: "M8.25223 19.222C8.10491 19.3647 7.93256 19.436 7.73519 19.436C7.53783 19.436 7.36595 19.3642 7.21956 19.2206C7.07319 19.077 7 18.909 7 18.7166C7 18.5243 7.07366 18.3567 7.22098 18.214C7.3683 18.0713 7.54065 18 7.73803 18C7.93538 18 8.10726 18.0718 8.25365 18.2154C8.40003 18.359 8.47321 18.527 8.47321 18.7194C8.47321 18.9118 8.39955 19.0793 8.25223 19.222Z",
    fill: "#183883"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneBill);
export default __webpack_public_path__ + "static/media/PhoneBill.64b1d96a1dad882eb6a050307d187f0e.svg";
export { ForwardRef as ReactComponent };